/**
 * Shared route configuration for the Creative system
 *
 * Flat 4-tab structure (no subtabs):
 *   displayUnits | displayGroups | videoUnits | videoGroups
 *
 * RESTful URL patterns:
 *   /creatives/display/units
 *   /creatives/display/groups
 *   /creatives/video/units
 *   /creatives/video/groups
 */
export const CREATIVE_ROUTE_CONFIG = {
  validTabs: ['displayUnits', 'displayGroups', 'videoUnits', 'videoGroups'],

  defaultRoute: {
    tab: 'displayUnits',
    page: 1,
  },

  // Map flat tab key → RESTful path segments
  tabToPath: {
    displayUnits:  { media: 'display', entity: 'units' },
    displayGroups: { media: 'display', entity: 'groups' },
    videoUnits:    { media: 'video',   entity: 'units' },
    videoGroups:   { media: 'video',   entity: 'groups' },
  },

  // Map RESTful path segments → flat tab key
  pathToTab: {
    'display-units':  'displayUnits',
    'display-groups': 'displayGroups',
    'video-units':    'videoUnits',
    'video-groups':   'videoGroups',
  },
};

/**
 * Check if a flat tab key is valid
 */
export const isValidTab = (tab) => {
  return CREATIVE_ROUTE_CONFIG.validTabs.includes(tab);
};

/**
 * Check if a page number is valid
 */
export const isValidPageNumber = (pageNumber) => {
  return !isNaN(pageNumber) && pageNumber > 0;
};

/**
 * Full route validation
 */
export const validateRouteParameters = (tab, _subtab, pageNumber) => {
  const isTab = isValidTab(tab);
  return {
    isValidTab: isTab,
    isValidSubtab: isTab, // backward compat — always same as isValidTab
    isValidPage: isValidPageNumber(pageNumber),
    isValid: isTab && isValidPageNumber(pageNumber),
  };
};
